import { TblBidDataDisplay } from '../../models/TblBidDataDisplay';

export class AddCurrentBidData {
  static readonly type = '[CurrentBidData] add';
  constructor(public payload: TblBidDataDisplay) {}
}

export class RemoveCurrentBidData {
  static readonly type = '[CurrentBidData] remove';
  constructor() {
    /**/
  }
}
